import React from "react";
import { Mail } from "lucide-react";

const SUPPORT_EMAIL = "becas@eimbecas.cl";

export const SupportLine = ({ className = "" }) => (
  <p className={`text-center text-xs text-muted-foreground ${className}`} data-testid="support-contact-line">
    ¿Tienes dudas? Escríbenos a{" "}
    <a href={`mailto:${SUPPORT_EMAIL}`} className="text-primary font-semibold hover:underline" data-testid="support-contact-email">
      {SUPPORT_EMAIL}
    </a>
  </p>
);

export const SupportFooter = () => (
  <footer className="border-t border-border bg-white" data-testid="support-footer">
    <div className="max-w-6xl mx-auto px-5 py-8 flex flex-col sm:flex-row items-center justify-between gap-3">
      <p className="text-sm text-muted-foreground">
        © {new Date().getFullYear()} Estadio Israelita Maccabi · Sitio privado y confidencial
      </p>
      <a
        href={`mailto:${SUPPORT_EMAIL}`}
        className="inline-flex items-center gap-2 text-sm font-semibold text-primary hover:underline"
        data-testid="support-footer-email"
      >
        <Mail className="w-4 h-4" /> ¿Dudas? {SUPPORT_EMAIL}
      </a>
    </div>
  </footer>
);
